import { EditorState } from 'prosemirror-state';
export const isProsemirrorState = editorState => {
  return editorState instanceof EditorState;
};
export const isProsemirrorRawContent = rawContent => {
  return rawContent && rawContent.doc && rawContent.selection;
};